import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toggleChatReadOnly, ToggleReadOnlyPayload } from "@/api/chats";
import { ChatsQueryKeys } from "@/tanstackQuery/queries/chats";

export const useToggleChatReadOnly = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: ToggleReadOnlyPayload) => toggleChatReadOnly(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [ChatsQueryKeys.Chats],
      });
      queryClient.invalidateQueries({
        queryKey: [ChatsQueryKeys.ChatsPaginated],
      });
    },
  });
};
